<template>
  <div class="house">
    <div class="headTitle">
      <div class="shadowTxt">DEVELOPMENT</div>
      <div class="title">地产开发</div>
      <div class="text">
        以“科技、健康、绿色”的设计理念打造“健康住宅”，提升企业产品核心竞争力，也为住户提供绿色健康、生态宜居的人居环境，让生活回归自然舒畅。以制造业“过度研发”之精神打造未来生活架构，创新颠覆传统地产行业理念，引领健康生活模式变革。
      </div>
    </div>
    <div class="f8f8f8"></div>
    <!-- 区域 -->
    <div>
      <MySelect :label="selectLabel" :data="selectData" @change="change" />
    </div>
    <div class="cityCont">
      <!-- 天津部分 -->
      <div class="tianJin">
        <!-- 天津图+文字 -->
        <div
          class="part"
          v-for="item in houses"
          :key="item.id"
          @click="showDialog(item)"
        >
          <div class="partImg">
            <img
              :src="'http://www.weaiove.com' + item.picture"
              alt=""
            />
          </div>
          <div class="houseTxt">
            <div class="title">{{ item.city }} | {{ item.title }}</div>
            <div class="address">{{ item.address }}</div>
            <div class="tell">电话：{{ item.tel }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog" v-show="showDiv">
      <Dwell :data="showData" @close="showDiv = false" />
    </div>
  </div>
</template>

<script>
import { apiGetArrlist } from "../../api/index";
import Dwell from "./dwell.vue";
import MySelect from "../../components/selectCom.vue";

export default {
  name: "house",
  metaInfo: {
        title: '地产开发-爱情地产',
        meta: [{
        name: 'keyWords',
        content: '爱情地产'
        },
        {
        name: 'description',
        content: ''
        }]
    },
  data() {
    return {
      areagroup: [],
      citygroup: [],
      houses: [],
      typegroup: [],
      selectLabel: [
        {
          label: "区域",
          value: "区域",
          name: "area",
        },
        {
          label: "城市",
          value: "城市",
          name: "city",
        },
        {
          label: "销售状况",
          value: "销售状况",
          name: "type",
        },
      ],
      selectData: {
        area: "",
        city: "",
        type: "",
      },
      params: {
        area: "",
        city: "",
        type: "",
      },
      showDiv: false,
      showData: {},
    };
  },
  components: {
    Dwell,
    MySelect,
  },
  methods: {
    change(type, val) {
      console.log(type, val);
      this.selectLabel.forEach((item) => {
        if (item.name == type) item.value = val;
      });
      this.params[type] = val;
      this.initParams();
    },
    showDialog(val) {
      this.showData = val;
      this.$nextTick(() => {
        this.showDiv = true;
      });
    },
    initParams() {
      let params = Object.entries(this.params)
        .map((res) => res[0] + "=" + res[1])
        .join("&");
      apiGetArrlist(params).then((data) => {
        this.areagroup = data.data.areagroup;
        this.citygroup = data.data.citygroup;
        this.typegroup = data.data.typegroup;
        this.houses = data.data.houses;
        this.selectData = {
          area: data.data.areagroup.map((res) => res.group),
          city: data.data.citygroup.map((res) => res.city),
          type: data.data.typegroup.map((res) => res.type),
        };
        if (!data.data.houses) this.dwellList = [];
      });
    },
  },
  created() {
    this.initParams();
  },
};
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}
.dialog {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(19, 20, 21, 0.6);
  z-index: 1000;
}
.house {
  background: #fff;
}
.headTitle {
  padding: 20px 15px 7px 15px;
  background: #fff;
  .shadowTxt {
    font-size: 40px;
    line-height: 47px;
    color: #f8f8f8;
    font-family: "DIN Alternate Bold";
    font-weight: bold;
  }
  .title {
    color: #222;
    font-size: 18px;
    line-height: 25px;
    font-family: "苹方-简 中黑体";
    font-weight: 600;
    margin-top: -28px;
  }
  .text {
    color: #666666;
    font-size: 13px;
    line-height: 20px;
    font-family: "苹方-简 常规体";
    margin-top: 9px;
  }
}
.f8f8f8{
  background: #F8F8F8;
  height: 11px;
  width: 100%;
}
.cityCont {
  /deep/.citySelect {
    padding: 13px 0 13px 0;
    background-color: #ffffff;
    border-bottom: 1px solid #efefef;
    display: flex;
    justify-content: space-around;
    .el-select {
      border-right: 1px solid #efefef;
      &:last-child {
        border-right: none;
      }
    }
    .el-input__inner {
      text-align: center;
      outline: none;
      border: none;
    }
  }
  .tianJin {
    padding: 0px 15px 20px 15px;
    box-sizing: border-box;
    margin-bottom: 20px;
    background: #fff;
    .part {
      border-radius: 10px;
      background-color: #ffffff;
      margin-top: 10px;
      box-shadow: 0 4px  14px 7px rgba(0,0,0,.05);
      .partImg {
        height: 151px;
        border-radius: 5px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .houseTxt {
        padding: 7px 22px 34px 15px;
        box-sizing: border-box;
      }
    }
  }
}
/deep/.el-select-dropdown {
  width: 100%;
}
/deep/.el-popper {
  width: 100%;
}
.title {
  color: #222222;
  line-height: 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: "苹方-简 中黑体";
}
.address {
  color: #666666;
  line-height: 17px;
  font-size: 12px;
  font-weight: 400;
  font-family: "苹方-简 常规体";
  margin: 3px 0 3px 0;
}
.tell {
  color: #666666;
  line-height: 17px;
  font-size: 12px;
  font-family: "苹方-简 常规体";
}
</style>
